import styled from 'styled-components';
import type {TicketPriority} from '../types/ticket';

const BADGE_BG: Record<TicketPriority, string> = {
	p0: '#fee2e2',
	p1: '#ffedd5',
	p2: '#fef9c3',
	p3: '#f1f5f9',
};
const BADGE_TEXT: Record<TicketPriority, string> = {
	p0: '#991b1b',
	p1: '#9a3412',
	p2: '#854d0e',
	p3: '#475569',
};
const DOT_COLOR: Record<TicketPriority, string> = {
	p0: '#ef4444',
	p1: '#fb923c',
	p2: '#facc15',
	p3: '#94a3b8',
};
const LABEL: Record<TicketPriority, string> = {
	p0: 'Critical',
	p1: 'High',
	p2: 'Medium',
	p3: 'Low',
};

const Badge = styled.span<{$priority: TicketPriority}>`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	padding: 2px 10px;
	border-radius: ${p => p.theme.sys.size.borderradius['1']};
	${p => p.theme.sys.font?.detail?.['1']}
	font-weight: 500;
	background: ${p => BADGE_BG[p.$priority]};
	color: ${p => BADGE_TEXT[p.$priority]};
`;

const Dot = styled.span<{$priority: TicketPriority}>`
	width: 8px;
	height: 8px;
	border-radius: 9999px;
	background: ${p => DOT_COLOR[p.$priority]};
`;

const UrgencyIconSvg = styled.svg`
	width: 16px;
	height: 16px;
	color: #dc2626;
`;

interface Props {
	priority: TicketPriority;
}

function UrgencyIcon() {
	return (
		<UrgencyIconSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" role="img">
			<title>Urgent</title>
			<path
				fillRule="evenodd"
				d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
				clipRule="evenodd"
			/>
		</UrgencyIconSvg>
	);
}

export function PriorityBadge({priority}: Props) {
	const label = LABEL[priority];
	return (
		<Badge $priority={priority} aria-label={`Priority: ${label}`}>
			{priority === 'p0' && <UrgencyIcon />}
			<Dot $priority={priority} aria-hidden="true" />
			<span>{label}</span>
		</Badge>
	);
}
